import React, { Fragment, useState } from "react";
import { Box, Modal, Typography, Grid, Button } from "@material-ui/core";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { useNavigate } from "react-router-dom";
import ButtonLoader from "./ButtonLoader";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";
import ToastModal from "./ToastModal";
import { Environment } from "../utils/environments";
import { setAnalyticsData } from "../utils/firebaseLog";

const SettingsModal = ({
  open,
  onClose,
  heading,
  secondHeading,
  buttonText,
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [checkedOne, setCheckedOne] = useState<boolean>(false);
  const [checkedTwo, setCheckedTwo] = useState<boolean>(false);
  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 700,
    bgcolor: "white",
    boxShadow: 24,
    p: 6,
  };
  async function handleCancelAccount() {
    setLoading(true);

    try {
      await httpPost({
        pathName: "cancel-account",
        bodyParams: {},
      }).then((response: AxiosResponse<any>) => {
        setAnalyticsData({ eventName: "cancelAccount" });
        signOut(auth);
        navigate("/login");
      });
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
        console.log(error.response.status);
      }
      if (
        error.response.status >= 400 &&
        error.response.status <= 499 &&
        error.response.data.message == "UNUSED_SUPPORT_TICKETS_ARE_AVAILABLE"
      ) {
        setShowToast(true);
      } else {
        navigate(`/error?code=${error.response.status}`);
      }
    } finally {
      setLoading(false);
    }
  }
  function closeModal() {
    if (loading) {
      return;
    }
    onClose(false);
    setCheckedOne(false);
    setCheckedTwo(false);
  }
  return (
    <Fragment>
      <Modal open={open} onClose={closeModal}>
        <Box className="modal-wrapper">
          <Box className="modal">
            {/* <div className="modal-heading">
              <div className="modal-heading-text">
                <Typography className="modal-title">退会</Typography>
              </div>
              <button className="back-btn" onClick={() => closeModal()}>
                閉じる
              </button>
            </div> */}
            <Box className="modal-body">
              <div>
                <Grid
                  container
                  justifyContent="center"
                  style={{ marginTop: "1.5rem" }}
                >
                  <Grid item md={10}>
                    <Typography
                      variant="h5"
                      color="primary"
                      style={{
                        fontWeight: "800",
                        marginBottom: "1.5rem",
                        fontFamily: "Noto Serif JP",
                      }}
                    >
                      退会されるとこれまでの会員情報が削除されます。
                      <br />
                      同じアカウントで再入会はできません。
                    </Typography>
                    <Typography
                      style={{
                        marginBottom: "2rem",
                        color: "var(--text-color-2)",
                        fontWeight: "800",
                      }}
                    >
                      よろしければ、すべてのチェックボックス
                      <br />
                      にチェックを入れてボタンを押してください。
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    md={12}
                    style={{ marginBottom: "1rem", textAlign: "left" }}
                  >
                    <input
                      type="checkbox"
                      name=""
                      id="input_one"
                      defaultChecked={checkedOne}
                      onChange={(e) => {
                        setCheckedOne(e.target.checked);
                      }}
                    />
                    <label
                      htmlFor="input_one"
                      style={{ marginLeft: "10px", fontSize: "0.9rem" }}
                    >
                      未使用のチケットは、払い戻しされないことを理解しています。
                    </label>
                  </Grid>
                  <Grid item md={12} style={{ textAlign: "left" }}>
                    <input
                      type="checkbox"
                      name=""
                      id="input_two"
                      defaultChecked={checkedTwo}
                      onChange={(e) => {
                        setCheckedTwo(e.target.checked);
                      }}
                    />
                    <label
                      htmlFor="input_two"
                      style={{ marginLeft: "10px", fontSize: "0.9rem" }}
                    >
                      このアカウントとアカウントに関連付けられているすべてのデータを削除します。
                    </label>
                  </Grid>
                </Grid>
                <Grid
                  container
                  justifyContent="center"
                  style={{ marginTop: "1.5rem" }}
                >
                  <Grid item md className="modal-button-wrapper">
                    <button
                      className="main-btn"
                      disabled={
                        (checkedOne == true && checkedTwo == true
                          ? false
                          : true) || loading
                      }
                      onClick={handleCancelAccount}
                    >
                      {loading ? <ButtonLoader btnColor="light" /> : buttonText}
                    </button>
                    <button
                      className="secondary-btn"
                      onClick={() => closeModal()}
                    >
                      戻る
                    </button>
                  </Grid>
                </Grid>
              </div>
            </Box>
          </Box>
        </Box>
      </Modal>
      {showToast && (
        <ToastModal
          errorModal={showToast}
          setErrorModal={setShowToast}
          message={"未使用のサポートチケットがあるため、退会できません"}
        />
      )}
    </Fragment>
  );
};

export default SettingsModal;
